/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');


// import Vue from 'vue';
// import Vuetify from 'vuetify';

// Vue.use(Vuetify);

// window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// import store from "./components/Vue/store/index";
// import vuetify from './vuetify';
// import AppSkeleton from './App-Skeleton';

// Vue.component('appSkeleton', require('./AppSkeleton.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


// new Vue({
//     vuetify,
//     store,

//     el: '#app',

//     components: { AppSkeleton }
// });
